export default __webpack_public_path__ + "static/media/ConnectSkill.b6d052ef.png";